<template>
  <div id="app">
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>

<script>
import {area_list,shoppingCartlist,copyRight,userImgList} from "@/api/xunyou";
export default {
    name: "App",
    provide(){
      return {
        reload:this.reload
      }
    },
    data(){
      return {
        userInfo: JSON.parse(localStorage.getItem("userdata")) || {},
        isRouterAlive:true
      }
    },
    created(){
      this.geTCopyright()
      this.getprovinceList()  
      this.getUserImg()
      if(this.userInfo.loginName!=null||this.userInfo.loginName!="" ){
          this.getshoppingCartlist();
      }   
    },
    methods:{
      // 获取版权名称
    geTCopyright(){
      copyRight().then(res=>{
        console.log(res)
        if(res.code==0){
          this.informations = res.rows[0]
          this.setGlobleTitle(this.informations.name||'讯有商城')
          if(this.informations.powstatus==1){
            this.$router.push('/erroPage')
          }else{
             this.$store.commit('getcopyRight',this.informations)
          }
        }
      }).catch(err=>{
        this.$message.error('查询失败,请稍后再试!')
      })
    },
      // 可刷新页面
      // reload(){
      //   this.isRouterAlive = false
      //   this.$nextTick(()=>{
      //     this.isRouterAlive = true
      //   })
      // },

      // 获取所有默认图片
    getUserImg(){
      userImgList().then(res=>{
          if(res.code==0){
            this.$store.commit('getUserImg',res.rows[0])
          }
        })
    },

       // 获取地址
       getprovinceList(){
           area_list()
               .then(res => {
               if (res.code == 0) {
                 this.$store.commit('getAddress',res.data)
               } else {
                   this.$message({
                     type: 'info',
                     message: res.msg
                   })
               }
               })
               .catch(err => {
               this.$message.error('获取地址失败，请稍后再试！')
               })
       },
      // 获取购物车
       getshoppingCartlist(){
           shoppingCartlist({uid:this.userInfo.userId||''})
               .then(res => {
                 console.log(res,'cccsss');
               if (res.length> 0) {
                 this.$store.commit('getCartList',res)
               }
            })
               .catch(err => {
               this.$message.error('购物车查询失败，请稍后再试！')
               })
       },
    }
};
</script>

<style> 
html,
body {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 0px;
    margin: 0px;
}
#app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    widows: 100%;
    height: 100%;
}
.el-popover.el-popper.backTopBox{
    top: auto !important;
    bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue